/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {ActionSheet, Toast} from 'react-weui'
import {renderMoney, getJsonFromUrl} from '../../utils'
import errorImg from '../../images/no-source.png'
import {fixBackContentEmpty} from "../../utils/index";


class WalletDetailHeader extends React.Component {

    constructor() {
        super();
        this.handleActionSheetShow = this.handleActionSheetShow.bind(this);
        this.handleActionSheetHide = this.handleActionSheetHide.bind(this);
        this.state = {
            selectBarShow: false,
            selectBarActions: [
                {
                    label: '取消',
                    onClick: this.handleActionSheetHide
                }
            ],
            ifIap: getJsonFromUrl().type === 'iap',
            selectType: 'all',
            selectedExpendSum: 0,     //支出
            selectedIncomeSum: 0,     //收入
            selectedSum: 0,            //金额
            selectedData: 0,           //总条数
            loadingToast: false,
            sheetList: [
                {type: 'all', name: '全部'},
                {type: 'lecture', name: '课程'},
                {type: 'channel', name: '专栏'},
                {type: 'liveroom_vip', name: 'VIP会员'},
                {type: 'relay', name: '转载'},
                {type: 'resell', name: '分销'},
                {type: 'redpack', name: '红包'},
                {type: 'reward', name: '打赏'},
                // {type:'recharge',name:'充值'},
                {type: 'refund', name: '退款'},
                {type: 'withdraw', name: '提现'},
                {type: 'change', name: '余额变动'},
                {type: 'gift', name: '赠礼'},
                {type: 'schedule', name: '打卡'},
                {type: 'share_rebate', name: '分享奖励'},
                {type: 'member', name: '超级会员分成'}
            ]
        };
    }

    componentDidMount() {
        document.title = '钱包明细';
        if (this.state.ifIap) {
            const {selectType} = this.state;
            this.props.dispatch({
                type: 'SET_WALLET_DETAIL_TYPE',
                payload: 'all'
            });
            axios.get('/api/wallet/iap/transaction', {
                params: {
                    filter_scene: selectType
                }
            }).then(res => {
                if (res.data.code === 0) {
                    let filterOptions = res.data.data.filter_options.map(item => ({type: item.key, name: item.name}));
                    filterOptions.push({type: '', name: ''});
                    this.setState({
                        selectedExpendSum: res.data.data.expend,     //支出
                        selectedIncomeSum: res.data.data.income,       //收入
                        sheetList: filterOptions
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_APPEND',
                        payload: res.data.data.trans
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出错。',
                            img: errorImg,
                            href: '/?st=wallet_404',
                            btn: '去首页看看'
                        }
                    });
                }
                console.log(error)
            });
        }
        else {
            const {selectType} = this.state;

            this.props.dispatch({
                type: 'SET_WALLET_DETAIL_TYPE',
                payload: 'all'
            });

            axios.get('/api/wallet/wallet_income_list', {
                params: {
                    filter_scene: selectType
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        selectedSum: res.data.data.sum_income,     // 金额
                        selectedData: res.data.data.sum_data        //总条数
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_APPEND',
                        payload: res.data.data.liveroom_transaction_list
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出错。',
                            img: errorImg,
                            href: '/?st=wallet_404',
                            btn: '去首页看看'
                        }
                    });
                }
                console.log(error)
            })
        }
    }

    componentWillUnmount() {
        this.props.dispatch({
            type: 'WALLET_DETAIL_CLEAR'
        })
    }

    handleActionSheetShow() {
        this.setState({
            selectBarShow: true
        })
    }

    handleActionSheetHide() {
        this.setState({
            selectBarShow: false
        })
    }

    handleSelect(type) {
        this.setState({
            selectType: type
        });

        this.props.dispatch({
            type: 'SET_WALLET_DETAIL_TYPE',
            payload: type
        });

        this.handleActionSheetHide();

        this.setState({
            loadingToast: true
        });
        if (this.state.ifIap) {
            axios.get('/api/wallet/iap/transaction', {
                params: {
                    filter_scene: type
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        loadingToast: false
                    });

                    document.body.scrollTop = 0;

                    this.setState({
                        selectedExpendSum: res.data.data.expend,     //支出
                        selectedIncomeSum: res.data.data.income      //收入
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_APPEND',
                        payload: res.data.data.trans
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出错。',
                            img: errorImg,
                            href: '/?st=wallet_404',
                            btn: '去首页看看'
                        }
                    });
                }
                console.log(error)
            });
        }
        else {
            axios.get('/api/wallet/wallet_income_list', {
                params: {
                    filter_scene: type
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        loadingToast: false
                    });

                    document.body.scrollTop = 0;

                    this.setState({
                        selectedSum: res.data.data.sum_income,     // 金额
                        selectedData: res.data.data.sum_data        //总条数
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_APPEND',
                        payload: res.data.data.liveroom_transaction_list
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出错。',
                            img: errorImg,
                            href: '/?st=wallet_404',
                            btn: '去首页看看'
                        }
                    });
                }
                console.log(error)
            });

        }
    }

    renderSheet() {
        const {selectType, sheetList} = this.state;

        return (
            <div className="wallet-detail-selectbar">
                <div className="selectbar-title">
                    选择筛选类型
                </div>
                <div className="selectbar-container">
                    <div className="row">
                        {sheetList.map((item, i) => {
                            return (
                                <div key={i} className={item.type !== ''
                                    ? 'selectbar-item ' + ((selectType === item.type) && 'selectbar-item-active')
                                    : 'selectbar-item-none'}
                                     onClick={item.type !== '' && this.handleSelect.bind(this, item.type)}>
                                    {item.name}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }

    renderTitle() {
        switch (this.state.selectType) {
            case 'lecture':
                return '课程';
            case 'channel':
                return '专栏';
            case 'liveroom_vip':
                return 'VIP会员';
            case 'relay':
                return '转载';
            case 'resell':
                return '分销';
            case 'redpack':
                return '红包';
            case 'reward':
                return '打赏';
            case 'refund':
                return '退款';
            case 'withdraw':
                return '提现';
            case 'change':
                return '余额变动';
            case 'gift':
                return '赠礼';
            case 'schedule':
                return '打卡';
            case 'all':
                return '全部';
            case 'share_rebate':
                return '分享奖励';
            case 'recharge':
                return '充值';
            case 'member':
                return '超级会员分成'
        }
    }

    render() {
        return (
            <div className="wallet-detail-header">
                <Toast icon="loading" show={this.state.loadingToast}/>
                <ActionSheet
                    menus={[{label: this.renderSheet()}]}
                    actions={this.state.selectBarActions}
                    show={this.state.selectBarShow}
                    type="ios"
                    onRequestClose={e => this.setState({selectBarShow: false})}
                />
                <p className="header-title">{this.renderTitle()}</p>
                {this.state.ifIap && <p className="header-text">支出 ￥{renderMoney(this.state.selectedExpendSum)}&nbsp;&nbsp;收入
                    ￥{renderMoney(this.state.selectedIncomeSum)}</p>}
                {!this.state.ifIap && <p className="header-text">金额 ￥{renderMoney(this.state.selectedSum)}&nbsp;&nbsp;
                    总计 {this.state.selectedData}条</p>}
                <div className="header-button" onClick={this.handleActionSheetShow}>
                    筛选
                </div>
            </div>
        )
    }
}




WalletDetailHeader.contextTypes = {
    page: React.PropTypes.object,
};

export default connect()(WalletDetailHeader)



// WEBPACK FOOTER //
// ./src/components/wallet/WalletDetailHeader.js